<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
            <!-- //文本搜索内容 -->
            <div class="fun-panel fun-search-form-wrapper">
                <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                    <a-row :gutter="[0, 6]">
                        <a-col :span="6">
                            <a-form-item label="申请单编号">
                                <a-input v-model="queryParams.rhsqbbh" placeholder="" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="单据状态">
                                <FGDictSelectCN dictNo="DW300101" v-model="queryParams.djzt" placeholder="" mode="multiple" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <span class="fun-search-form-buttons" :style="{ float: 'right', overflow: 'hidden' }">
                                <a-button type="primary" @click="loadData">查询</a-button>
                                <a-button style="margin-left: 8px" @click="reset">重置</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
        </a-anchor>
        <div class="fun-panel">
            <a-spin :spinning="tableDataLoading">
                <vxe-toolbar
                    size="mini"
                    custom
                    :refresh="{
                        query: () => {
                            this.loadData();
                        }
                    }"
                >
                    <template v-slot:buttons>
                        <a-button type="primary" icon="plus" @click="insert">新增</a-button>
                        <a-button-group class="btnGroupCls">
                            <a-button :type="selDJZT === 0 ? btnPrimary : btnDefault" @click="handleSelDjztChange(0)">
                                全部
                            </a-button>
                            <a-button :type="selDJZT === 1 ? btnPrimary : btnDefault" @click="handleSelDjztChange(1)">
                                待提交
                            </a-button>
                            <a-button :type="selDJZT === 2 ? btnPrimary : btnDefault" @click="handleSelDjztChange(2)">
                                已提交
                            </a-button>
                        </a-button-group>
                    </template>
                </vxe-toolbar>

                <vxe-table
                    ref="table"
                    size="mini"
                    resizable
                    row-id="id"
                    auto-resize
                    align="left"
                    :max-height="$FG_util.getTableHeightDirect(1)"
                    show-overflow="tooltip"
                    header-align="center"
                    :data="tableData"
                    highlight-hover-row
                    highlight-current-row
                    :sort-config="{
                        trigger: 'cell',
                        defaultSort: { field: sort.field, order: sort.order },
                        remote: true,
                        orders: ['asc', 'desc']
                    }"
                    @sort-change="handleSortChange"
                    @cell-dblclick="doubleClick"
                >
                    <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                    <vxe-table-column field="djzt" title="单据状态" width="90" align="center"></vxe-table-column>
                    <vxe-table-column field="rhsqbbh" title="申请表编号" width="120" sortable align="center"></vxe-table-column>
                    <vxe-table-column field="dwbh" title="单位编号" width="100" sortable align="center"></vxe-table-column>
                    <vxe-table-column field="dwmc" title="单位名称" min-width="160" sortable></vxe-table-column>
                    <vxe-table-column field="dwlx" title="单位类型" width="100" sortable align="center"> </vxe-table-column>
                    <vxe-table-column field="dwlb" title="单位类别" width="100" sortable align="center"></vxe-table-column>
                    <vxe-table-column field="qymc" title="区域名称" width="90" sortable align="center"> </vxe-table-column>
                    <vxe-table-column field="hyfl" title="行业分类" width="100" sortable align="center"></vxe-table-column>
                    <vxe-table-column field="dwxz" title="单位性质" width="100" sortable align="center"> </vxe-table-column>
                    <vxe-table-column field="zxdj" title="资信等级" width="100" sortable align="center"> </vxe-table-column>
                    <vxe-table-column field="zcsj" title="注册时间" width="120" sortable align="center"></vxe-table-column>
                    <vxe-table-column field="lrr" title="录入人" width="100" sortable align="center"></vxe-table-column>
                    <vxe-table-column field="tjrq" title="提交日期" width="150" sortable align="center"></vxe-table-column>
                    <vxe-table-column title="操作" width="140" align="center">
                        <template v-slot="scope">
                            <span
                                class="btn_edit"
                                v-if="scope.row.djzt === '制定' || scope.row.djzt === '撤销' || scope.row.djzt === '否决'"
                                @click="remove(scope.row)"
                                >删除</span
                            >
                            <span
                                class="btn_edit"
                                v-if="scope.row.djzt === '制定' || scope.row.djzt === '撤销' || scope.row.djzt === '否决'"
                                @click="edit(scope.row)"
                                >编辑</span
                            >
                            <span class="btn_edit" @click="view(scope.row)">查看</span>
                        </template>
                    </vxe-table-column>
                </vxe-table>
                <vxe-pager
                    background
                    size="mini"
                    :current-page.sync="pageinfo.pageNo"
                    :page-size.sync="pageinfo.pageSize"
                    :total="pageinfo.total"
                    :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
                    @page-change="handlePageChange"
                >
                </vxe-pager>
            </a-spin>
        </div>
    </div>
</template>
<script>
export default {
    name: "RhsqBrowse",
    props: ["showEdit", "dataId"],
    data() {
        return {
            // 分页
            pageinfo: {
                pageNo: 1,
                pageSize: 10,
                total: 0
            },
            // 排序
            sort: {
                field: "rhsqbbh",
                order: "desc"
            },
            // 查询条件
            queryParams: {},
            //表格数据
            tableData: [],
            tableDataLoading: false,
            // 从表排序
            itemSort: {
                field: "xh",
                order: "asc"
            },
            //从表表格数据
            itemTableData: [],
            itemTableDataLoading: false,
            btnPrimary: "primary",
            btnDefault: "default",
            selDJZT: 1,
            isShow_qybh: false,
            isShow_qymc: false
        };
    },
    computed: {
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
            }
        },
        formIsVisible: {
            get() {
                return this.showForm;
            },
            set(newVal) {
                this.$emit("update:showForm", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        }
    },
    activated() {
        this.loadData(this.editDataId);
    },
    methods: {
        //双击事件
        doubleClick({ row }) {
            if (this.getState(row.djzt) === 2) {
                this.view(row);
            } else {
                this.edit(row);
            }
        },
        getState(state) {
            if (state === "制定" || state === "撤销" || state === "否决") {
                return 1;
            } else {
                return 2;
            }
        },
        //选择不同状态
        handleSelDjztChange(djzt) {
            this.selDJZT = djzt;
            this.loadData();
        },
        //重置查询条件
        reset() {
            this.queryParams = {};
        },
        //点击页码
        handlePageChange({ currentPage, pageSize }) {
            this.pageinfo.pageNo = currentPage;
            this.pageinfo.pageSize = pageSize;
            this.loadData();
        },
        //点击表头排序 { property, order }
        handleSortChange({ property, order }) {
            this.sort.field = property;
            this.sort.order = order;
            this.loadData();
        },
        // 新增
        insert() {
            // 设置编辑记录id
            this.editDataId = null;
            // 显示编辑界面
            this.editIsVisible = true;
        },
        // 编辑
        edit(row) {
            // 设置编辑记录id
            this.editDataId = row.id;
            // 显示编辑界面
            this.editIsVisible = true;
        },
        // 刷新并选中指定记录
        loadData(id) {
            this.queryParams.selType = this.selDJZT;
            // 如果没有指定选中记录则选中刷新前选中的记录
            if (!id) {
                let row = this.$refs.table.getCurrentRecord();
                if (row) {
                    id = row.id;
                }
            }
            this.tableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxdw/hyrhgl/listWTJ",
                    {
                        funid: "DW3001",
                        menuid: "880DFC5B-1D82-4C3F-A3FE-71E8CF8419D4",
                        defaulttablename: "DW_RHSQB",
                        pageNo: this.pageinfo.pageNo,
                        pageSize: this.pageinfo.pageSize,
                        queryParams: this.queryParams,
                        sort: this.sort
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;
                    if (success) {
                        this.tableData = data.data;
                        // 需要设置当前页，因为查询可能导致当前页发生变化
                        this.pageinfo.pageNo = data.pageinfo.pagenum;
                        this.pageinfo.total = data.pageinfo.maxrow;
                    } else {
                        // 数据加载失败清空表格
                        this.tableData = [];
                    }
                })
                .then(() => {
                    this.$nextTick(() => {
                        let row = null;
                        // 获取之前选择的记录
                        if (id) {
                            row = this.$refs.table.getRowById(id);
                        }
                        // 如果之前没有选择记录且表格不为空则选择第一条记录
                        if (!row && this.tableData.length > 0) {
                            row = this.$refs.table.getRowById(this.tableData[0].id);
                        }
                        if (row) {
                            // 设置当前记录
                            this.$refs.table.setCurrentRow(row);
                        } else {
                            // 清空当前行
                            this.$refs.table.clearCurrentRow();
                        }
                    });
                });
        },
        // 点击明细表头排序 { property, order }
        handleItemSortChange({ property, order }) {
            this.itemSort.field = property;
            this.itemSort.order = order;
        },
        //查看
        view(row) {
            // 设置编辑记录id
            this.editDataId = row.id;
            // 显示编辑界面
            this.editIsVisible = false;
            this.formIsVisible = true;
        },
        // 删除
        remove(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    this.tableDataLoading = true;
                    this.$FG_http
                        .post("./api/main/zxdw/hyrhgl/delete", {
                            id: row.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                this.loadData();
                            }
                        });
                }
            });
        }
    }
};
</script>
